// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.km-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(72, 80, 40, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.km-modal {
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
  padding: 2rem 2.5rem;
  width: 90%;
  max-width: 440px;
  text-align: center;
}

.km-modal-icon {
  font-size: 3rem;
  color: var(--dunkelgruen);
  display: block;
  margin: 0 auto 0.5rem;
}

.km-modal-message {
  font-family: 'Circular', sans-serif;
  font-size: 1.1rem;
  color: var(--dunkelgruen);
  margin: 0 0 1.5rem;
}

.km-modal-buttons {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
}

.km-modal-buttons button {
  width: auto;
  min-width: 130px;
  margin: 0;
  padding: 12px 20px;
  background-color: var(--dunkelgruen);
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Staatliches', sans-serif;
  text-transform: uppercase;
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/SuccessModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".km-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(72, 80, 40, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.km-modal {\n  background-color: #fff;\n  border-radius: 20px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);\n  padding: 2rem 2.5rem;\n  width: 90%;\n  max-width: 440px;\n  text-align: center;\n}\n\n.km-modal-icon {\n  font-size: 3rem;\n  color: var(--dunkelgruen);\n  display: block;\n  margin: 0 auto 0.5rem;\n}\n\n.km-modal-message {\n  font-family: 'Circular', sans-serif;\n  font-size: 1.1rem;\n  color: var(--dunkelgruen);\n  margin: 0 0 1.5rem;\n}\n\n.km-modal-buttons {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.km-modal-buttons button {\n  width: auto;\n  min-width: 130px;\n  margin: 0;\n  padding: 12px 20px;\n  background-color: var(--dunkelgruen);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: 'Staatliches', sans-serif;\n  text-transform: uppercase;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
